import { render, staticRenderFns } from "./autocomplete.loads.vue?vue&type=template&id=b79fcb8a&scoped=true&v-slot%3Acombobox=true"
import script from "./autocomplete.loads.vue?vue&type=script&lang=js"
export * from "./autocomplete.loads.vue?vue&type=script&lang=js"
import style0 from "./autocomplete.loads.vue?vue&type=style&index=0&id=b79fcb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79fcb8a",
  null
  
)

export default component.exports